<template>
  <!--
  作者：luoyiming
  时间：2019-10-24
  描述：医院通知
  -->
  <div>
    <!--nav start-->
    <div id="nav">
      <ul class="nav">
        <li :class="routerstr.indexOf('index') != -1 ? 'active' : ''" @click="pageClick('/index')">首页</li>
        <li :class="routerstr.indexOf('notice') != -1 ? 'active' : ''" @click="pageClick('/notice')">医院通知</li>
        <li :class="routerstr.indexOf('news') != -1 ? 'active' : ''" @click="pageClick('/news')">新闻中心</li>
        <li :class="routerstr.indexOf('message') != -1 ? 'active' : ''" @click="pageClick('/message')">信息公告</li>
        <li :class="routerstr.indexOf('department') != -1 ? 'active' : ''" @click="pageClick('/department')">科室介绍</li>
        <li :class="routerstr.indexOf('information') != -1 ? 'active' : ''" @click="pageClick('/information')">健康资讯</li>
        <li :class="routerstr.indexOf('contact') != -1 ? 'active' : ''" @click="pageClick('/contact')">联系我们</li>
      </ul>
    </div>
    <!--nav end-->
    <div class="message_title">新闻中心</div>
    <div class="list_tab">
      <div class="list_tab_content">
        <div class="list_tab_item" :class="year == item.year ? 'active' : ''" v-for="(item, index) in yearlist" :key="index"
          @click="tabClick(item.year)">{{ item.year }}年度</div>
      </div>
    </div>
    <!--start type-->
    <div class="news_list_type">
      <div class="news_list_type_item" @click="clickType('image')">
        <img v-if="typeStatus == 'image'" src="../../static/imgs/list_image_active.png" width="60" height="60" alt="">
        <img v-else src="../../static/imgs/list_image.png" width="60" height="60" alt="">
      </div>
      <div class="news_list_type_item" @click="clickType('imagetext')">
        <img v-if="typeStatus == 'imagetext'" src="../../static/imgs/list_imagetext_active.png" width="60" height="60"
          alt="">
        <img v-else src="../../static/imgs/list_imagetext.png" width="60" height="60" alt="">
      </div>
      <div class="news_list_type_item" @click="clickType('text')">
        <img v-if="typeStatus == 'text'" src="../../static/imgs/list_text_active.png" width="60" height="60" alt="">
        <img v-else src="../../static/imgs/list_text.png" width="60" height="60" alt="">
      </div>
    </div>
    <!--end type-->
    <div class="news_list" :class="'news_list_' + typeStatus">
      <!--item start-->
      <div class="news_list_item" v-for="(item, index) in list" :key="index" :class="'news_list_item_' + typeStatus"
        @click="pageQueryClick('/newsdetail', item.newsId)">
        <div class="news_item_img">
          <img :src="'/dev-api' + item.coverPicPath" alt="">
        </div>
        <div class="news_item_content">
          <div class="news_item_content_title">{{ item.title }}</div>
          <div class="news_item_content_info" v-html="item.content"></div>
          <div class="news_item_content_time"><span>{{ item.createTime }}</span></div>
        </div>
      </div>
      <!--item end-->
    </div>
    <!--end-->
    <div>
      <Page :total="total" :page-size="limit" @on-change="pageChange" @on-prev="pagePrev" @on-next="pageNext" show-total
        prev-text="上一页" next-text="下一页" />
    </div>
  </div>
</template>

<script>
import IndexApi from '@/api/index.js';
export default {
  data() {
    return {
      routerstr: '/news',
      /*是否正在加载*/
      loading: true,
      /*背景图片*/
      bgimg_url: '',
      /*是否正在提交*/
      logining: false,
      /*基础配置*/
      list: [],
      yearlist: [],
      year: '',
      total: 0,
      page: 1,
      limit: 12,
      typeStatus: 'image',
    };
  },
  created() {
    this.getyear();
    this.getInformation();
    /*this.routerstr = this.$router.currentRoute.path;*/
  },
  methods: {
    pageChange(e) {
      this.page = e;
      this.getInformation();
    },
    pagePrev(e) {
      this.page = e;
      this.getInformation();
    },
    pageNext(e) {
      this.page = e;
      this.getInformation();
    },
    clickType(str) {
      this.typeStatus = str;
    },
    tabClick(str) {
      this.year = str;
      this.getInformation();
    },
    /*页面跳转*/
    pageClick(row) {
      this.$router.push(row);
    },
    /*页面跳转*/
    pageQueryClick(row, id) {
      this.$router.push({ path: row, query: { id: id } });
    },
    getInformation() {
      let self = this;
      var data = {
        page: self.page,
        limit: self.limit,
        year: self.year,
      }
      IndexApi.news(data, true)
        .then(res => {
          self.loading = false;
          self.list = res.data.list;
          self.total = res.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getyear() {
      let self = this;
      var data = {}
      IndexApi.newsYear(data, true)
        .then(res => {
          self.loading = false;
          self.yearlist = res.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.ivu-page {
  margin: 60px auto 0;
  width: 700px;
}


.message_title {
  height: 150px;
  background: #007E4F;
  line-height: 150px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  font-weight: bold;
}

.list_tab {
  height: 80px;
  position: relative;

  .list_tab_content {
    width: 900px;
    margin: 0 auto;
    display: flex;

    .list_tab_item {
      font-size: 20px;
      color: #666666;
      line-height: 80px;
      padding: 0 20px;
      cursor: pointer;
    }

    .list_tab_item.active {
      color: #007E4F;
      position: relative;
    }

    .list_tab_item.active::before {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      right: 0;
      height: 2px;
      background: #007E4F;
    }
  }
}

.list_tab::before {
  position: absolute;
  content: '';
  left: 0;
  bottom: 0;
  right: 0;
  height: 2px;
  background: #DEDEDE;
}

.news_list_type {
  width: 900px;
  margin: 40px auto;
  height: 80px;
  display: flex;

  .news_list_type_item {
    padding: 0 10px;
    cursor: pointer;
  }
}

.news_list {
  width: 900px;
  margin: 0 auto;
}

.news_list_item {
  cursor: pointer;
}

/*平铺图*/
.news_list_image {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .news_list_item_image {
    width: 290px;
    height: 395px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
    background: #fff;
    margin: 0 0 40px 0;

    .news_item_img {
      display: flex;
      justify-content: center;
      img {
        width: 280px;
        height: 200px;
      }
    }
  }

  .news_item_content_title {
    height: 148px;
    padding:20px 20px  ;
    overflow: hidden;
    font-size: 18px;
    color: #333;
    position: relative;
  }

  .news_item_content_title::before {
    position: absolute;
    content: '';
    left: 0;
    bottom: 0;
    right: 0;
    height: 2px;
    background: #DEDEDE;
  }

  .news_item_content_info {
    display: none;
  }

  .news_item_content_time {
    height: 52px;
    line-height: 52px;
    padding: 0 40px;
    font-size: 20px;
    color: #333;
    text-align: right;
  }
}

/*图文*/
.news_list_imagetext {
  .news_list_item_imagetext {
    border-radius: 5px;
    border: 2px solid #DEDEDE;
    margin-bottom: 30px;
    display: flex;
    align-items: center;

    .news_item_img {
      img {
        width: 268px;
        height: 200px;
        padding: 8px;
      }
    }
  }

  .news_item_content {
    padding: 0 0 0 30px;
    width: 100%;

    .news_item_content_title {
      font-size: 20px;
      color: #333;
      height: 50px;
      line-height: 50px;
      overflow: hidden;
      margin-top: 24px;
      
    }


    .news_item_content_info {
      height: 10px;
      line-height: 31px;
      margin: 30px 0 0 0;
      font-size: 22px;
      color: #333;
      overflow: hidden;
      visibility: hidden;
    }

    .news_item_content_time {
      height: 28px;
      line-height: 28px;
      font-size: 20px;
      color: #666;
      padding: 0 0 0 18px;
      position: relative;
      bottom: 30px;
    }

    .news_item_content_time::before {
      position: absolute;
      content: '';
      left: 0;
      bottom: 10px;
      width: 8px;
      height: 8px;
      background: #999;
      border-radius: 8px;
    }
  }
}

/*文本*/
.news_list_text {
  .news_list_item_text {
    .news_item_img {
      display: none;
    }

    .news_item_content {
      height: 99px;
      line-height: 99px;
      display: flex;
      border-top: 2px solid #DEDEDE;
      border-bottom: 2px solid #DEDEDE;
      margin-bottom: 20px;
      justify-content: space-between;

      .news_item_content_title {
        font-size: 22px;
        color: #333;
        padding: 0 30px;
        line-height: 99px;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 700px;
      }

      .news_item_content_info {
        display: none;
      }

      .news_item_content_time {
        font-size: 20px;
        color: #666;
        line-height: 99px;
        padding: 0 30px 0 18px;
        position: relative;
      }

      .news_item_content_time::before {
        position: absolute;
        content: '';
        left: 0;
        bottom: 43px;
        width: 8px;
        height: 8px;
        border-radius: 8px;
        background: #999;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/news.vue